/** @format */

// 获取模型默认值
export const getDefaultValue = (widgetDatas: any[]) =>
	[...widgetDatas].reduce((obj, item) => {
		item.children?.forEach((itm) => {
			const defaultValue = toRaw(itm.options.defaultValue);
			itm.options.defaultValue && (obj[itm.options.code as string] = defaultValue);
		});
		return obj;
	}, {});
